import { clearUrl, validateURL } from '@elfsight/widget-utils';
import type { AudioItem, Source } from '../../../../types';

export function radio(source: Source) {
  if (!Array.isArray(source)) {
    return;
  }

  return new Promise<(AudioItem | null)[]>((resolve) => {
    const result = source.map(
      ({
        id,
        title = '',
        author = '',
        link,
        image,
        _radioMetadata: metadataSettings
      }) => {
        if (typeof link !== 'string' || !validateURL(link)) {
          return null;
        }

        const { url: imageUrl } = image ?? {};

        return {
          id,
          author,
          link,
          metadataSettings,
          image: imageUrl,
          title: title || clearUrl(link) || ''
        };
      }
    );

    resolve(result);
  });
}
